/**
 * A custom directive to handle clearing spaces from model.
 */
App.directive('ngRemoveSpaces', function() {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            /**
             * Watch out for change of the model. This will trigger
             * clearing spaces in the value.
             */
            scope.$watch(function () {
				return ngModel.$modelValue;
			}, function(newValue) {
				if(newValue)
				{
					ngModel.$setViewValue(newValue.replace(" ","."));
            		ngModel.$render();
				}
			});
        }
    }
});
